export default __webpack_public_path__ + "static/media/logo.350a2249.png";